export const generateWhatsAppScript = ({ phone, message }) => {
  // Sanitizar y formatear el número de teléfono
  const cleanPhone = phone.replace(/\D/g, '');
  
  // Codificar el mensaje para la URL
  const encodedMessage = encodeURIComponent(message);

  // Generar el script como string
const scriptContent = `
    const whatsappButton = document.createElement('a');
    whatsappButton.href = 'https://wa.me/${cleanPhone}?text=${encodedMessage}';
    whatsappButton.target = '_blank';
    whatsappButton.style.position = 'fixed';
    whatsappButton.style.bottom = '50px';
    whatsappButton.style.left = '20px';
    whatsappButton.style.background = '#128C7E';
    whatsappButton.style.color = '#fff';
    whatsappButton.style.padding = '12px 20px';
    whatsappButton.style.borderRadius = '50px';
    whatsappButton.style.boxShadow = '0 2px 5px rgba(0,0,0,0.3)';
    whatsappButton.style.textDecoration = 'none';
    whatsappButton.style.fontFamily = 'sans-serif';
    whatsappButton.style.fontSize = '14px';
    whatsappButton.textContent = 'Chatear por WhatsApp';

    document.body.appendChild(whatsappButton);
`;

  return {
    type: 'whatsapp',
    target: 'body',
    content: scriptContent.trim(),
    generateScript: () => {        
      const script = document.createElement('script');
      script.textContent = scriptContent;
      return script;
    }
  };
};

